(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zen-flow-experience"] && !Shopify.designMode) return;
  try {
    class ZenFlowExperience extends HTMLElement {
  connectedCallback() {
    const id = this.querySelector('[id*="zf-grid-"]').id.replace('zf-grid-', '');
    this._id = id;
    this._code = this.dataset.code || 'MYRITUAL';
    this._discount = this.dataset.discount || '20% de descuento en divain. RITUAL';
    this._revealed = 0;
    this._checkedDays = JSON.parse(localStorage.getItem('zf_tracker_' + id) || '[]');

    const i18n = (window.zenFlowI18n || {});
    const i18nDays = i18n.days || [];
    // Preserve original day types + icons (structural, not translated)
    const dayMeta = [
      {type:'progreso',icon:'🌱'},
      {type:'sabias',icon:'🧠'},
      {type:'reto',icon:'📵'},
      {type:'progreso',icon:'🌿'},
      {type:'sabias',icon:'🌿'},
      {type:'reto',icon:'✍️'},
      {type:'progreso',icon:'💤'},
      {type:'sabias',icon:'🌊'},
      {type:'reto',icon:'🚶'},
      {type:'progreso',icon:'🧬'},
      {type:'sabias',icon:'🌺'},
      {type:'reto',icon:'⏰'},
      {type:'progreso',icon:'⚡'},
      {type:'sabias',icon:'💙'},
      {type:'reto',icon:'🧘'},
      {type:'progreso',icon:'🌙'},
      {type:'sabias',icon:'🌿'},
      {type:'reto',icon:'🌡️'},
      {type:'progreso',icon:'🧠'},
      {type:'sabias',icon:'🦠'},
      {type:'reto',icon:'☀️'},
      {type:'progreso',icon:'💆'},
      {type:'sabias',icon:'🌙'},
      {type:'reto',icon:'📖'},
      {type:'progreso',icon:'🌟'},
      {type:'sabias',icon:'⚗️'},
      {type:'reto',icon:'🧊'},
      {type:'progreso',icon:'🔄'},
      {type:'sabias',icon:'🌱'},
      {type:'reto',icon:'🤫'},
      {type:'progreso',icon:'🏆'}
    ];
    this._days = dayMeta.map((m, idx) => ({
      type: m.type,
      icon: m.icon,
      headline: (i18nDays[idx] && i18nDays[idx].headline) || '',
      body: (i18nDays[idx] && i18nDays[idx].body) || ''
    }));
    this._i18n = i18n;

    this._initOverlays();
    this._initTracker();
    this._initModals();
  }

  _initOverlays() {
    const id = this._id;
    ['adapt','mind','dreams'].forEach((card, i) => {
      const overlay = this.querySelector(`#zf-overlay-${card}-${id}`);
      if (!overlay) return;
      overlay.addEventListener('click', () => {
        if (overlay.classList.contains('hidden')) return;
        overlay.classList.add('hidden');
        overlay.setAttribute('aria-expanded', 'true');
        overlay.closest('.zf-card').classList.add('revealed');
        overlay.closest('.zf-card').querySelector('.zf-card-content').removeAttribute('aria-hidden');
        this._revealed++;
        this._updateProgress();
        if (this._revealed === 3) {
          setTimeout(() => {
            const cel = this.querySelector(`#zf-celebration-${id}`);
            cel.removeAttribute('hidden');
            cel.querySelector(`#zf-cel-btn-${id}`).focus();
          }, 600);
        }
      });
    });
  }

  _updateProgress() {
    const id = this._id;
    const fill = this.querySelector(`#zf-fill-${id}`);
    const count = this.querySelector(`#zf-count-${id}`);
    const region = this.querySelector(`#zf-progress-region-${id}`);
    if (fill) fill.style.inlineSize = (this._revealed / 3 * 100) + '%';
    if (count) count.textContent = this._revealed + '/3';
    if (region) region.setAttribute('aria-valuenow', this._revealed);
  }

  _initTracker() {
    const id = this._id;
    const grid = this.querySelector(`#zf-grid-${id}`);
    if (!grid) return;
    const types = {progreso:'t-progreso', sabias:'t-sabias', reto:'t-reto'};
    const ariaPlain = (this._i18n.day_aria && this._i18n.day_aria.plain) || 'Día {n}';
    const ariaDone = (this._i18n.day_aria && this._i18n.day_aria.completed) || 'Día {n} — completado';
    for (let i = 0; i < 30; i++) {
      const btn = document.createElement('button');
      const type = this._days[i].type;
      const isChecked = this._checkedDays.includes(i+1);
      btn.type = 'button';
      btn.className = 'zf-day-btn ' + types[type] + (isChecked ? ' checked' : '');
      btn.setAttribute('aria-label', (isChecked ? ariaDone : ariaPlain).replace('{n}', i+1));
      btn.setAttribute('aria-pressed', isChecked ? 'true' : 'false');
      btn.innerHTML = isChecked ? '✓' : '<span aria-hidden="true">' + (i+1) + '</span><span class="zf-day-dot" aria-hidden="true"></span>';
      btn.addEventListener('click', () => this._handleDayTap(i+1, btn, i));
      grid.appendChild(btn);
    }
    this._updateStreak();
  }

  _handleDayTap(n, btn, idx) {
    const ariaPlain = (this._i18n.day_aria && this._i18n.day_aria.plain) || 'Día {n}';
    const ariaDone = (this._i18n.day_aria && this._i18n.day_aria.completed) || 'Día {n} — completado';
    if (this._checkedDays.includes(n)) {
      this._checkedDays = this._checkedDays.filter(d => d !== n);
      btn.classList.remove('checked');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', ariaPlain.replace('{n}', n));
      btn.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="zf-day-dot" aria-hidden="true"></span>';
    } else {
      this._checkedDays.push(n);
      btn.classList.add('checked');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', ariaDone.replace('{n}', n));
      btn.textContent = '✓';
      this._openDayModal(idx);
    }
    localStorage.setItem('zf_tracker_' + this._id, JSON.stringify(this._checkedDays));
    this._updateStreak();
  }

  _openDayModal(idx) {
    const id = this._id;
    const d = this._days[idx];
    const modal = this.querySelector(`#zf-day-modal-${id}`);
    const m = this._i18n.modal || {};
    const ariaProgress = (m.aria_day_progress_template || 'Tu progreso — Día {n}').replace('{n}', idx+1);
    const labels = {
      progreso: d.icon + ' ' + ariaProgress,
      sabias:   d.icon + ' ' + (m.aria_did_you_know || '¿Sabías que?'),
      reto:     d.icon + ' ' + (m.aria_challenge || 'Reto del día')
    };
    this.querySelector(`#zf-modal-badge-${id}`).className = 'zf-modal-badge ' + d.type;
    this.querySelector(`#zf-modal-badge-${id}`).textContent = labels[d.type];
    this.querySelector(`#zf-modal-day-label-${id}`).textContent = (m.day_of_30_template || 'Día {n} de 30').replace('{n}', idx+1);
    this.querySelector(`#zf-modal-headline-${id}`).textContent = d.headline;
    this.querySelector(`#zf-modal-body-${id}`).textContent = d.body;
    modal.removeAttribute('hidden');
    this.querySelector(`#zf-modal-close-${id}`).focus();
    this._showTodayBanner(idx);
  }

  _showTodayBanner(idx) {
    const id = this._id;
    const d = this._days[idx];
    const banner = this.querySelector(`#zf-today-${id}`);
    const badge = this.querySelector(`#zf-today-badge-${id}`);
    const m = this._i18n.modal || {};
    const labels = {
      progreso: '🌱 ' + (m.tag_progress || 'Tu progreso').replace(/^🌱\s*/, ''),
      sabias:   '💡 ' + (m.tag_did_you_know || '¿Sabías que?').replace(/^💡\s*/, ''),
      reto:     '🎯 ' + (m.tag_challenge || 'Reto del día').replace(/^🎯\s*/, '')
    };
    badge.className = 'zf-today-badge ' + d.type;
    badge.textContent = labels[d.type];
    this.querySelector(`#zf-today-day-${id}`).textContent = (m.day_of_30_template || 'Día {n} de 30').replace('{n}', idx+1);
    this.querySelector(`#zf-today-content-${id}`).innerHTML = '<strong>' + d.headline + '</strong> ' + d.body;
    banner.removeAttribute('hidden');
  }

  _updateStreak() {
    const sorted = [...this._checkedDays].sort((a,b) => a-b);
    let streak = 0;
    for (let i = 1; i <= 30; i++) {
      if (sorted.includes(i)) streak++;
      else if (streak > 0) break;
    }
    const el = this.querySelector(`#zf-streak-${this._id}`);
    if (el) el.textContent = streak;
    if (sorted.length > 0) this._showTodayBanner(sorted[sorted.length-1]-1);
    if (streak === 30) {
      setTimeout(() => {
        const reward = this.querySelector(`#zf-reward-${this._id}`);
        reward.removeAttribute('hidden');
        reward.querySelector('.zf-reward-close').focus();
      }, 800);
    }
  }

  _initModals() {
    const id = this._id;
    // Day modal close
    const dayModalClose = this.querySelector(`#zf-modal-close-${id}`);
    if (dayModalClose) dayModalClose.addEventListener('click', () => {
      this.querySelector(`#zf-day-modal-${id}`).setAttribute('hidden', '');
    });
    // Celebration close → scroll to timeline
    const celBtn = this.querySelector(`#zf-cel-btn-${id}`);
    if (celBtn) celBtn.addEventListener('click', () => {
      this.querySelector(`#zf-celebration-${id}`).setAttribute('hidden', '');
      const timeline = this.querySelector('.zf-timeline');
      if (timeline) setTimeout(() => timeline.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    });
    // Reward close
    const rewardClose = this.querySelector(`#zf-reward-close-${id}`);
    if (rewardClose) rewardClose.addEventListener('click', () => {
      this.querySelector(`#zf-reward-${id}`).setAttribute('hidden', '');
    });
    // Copy code
    const codeBlock = this.querySelector(`#zf-code-block-${id}`);
    if (codeBlock) codeBlock.addEventListener('click', () => {
      navigator.clipboard.writeText(this._code).catch(() => {});
      codeBlock.classList.add('copied');
    });
    // Close modals on backdrop click
    this.querySelector(`#zf-day-modal-${id}`)?.addEventListener('click', e => {
      if (e.target === e.currentTarget) e.currentTarget.setAttribute('hidden','');
    });
    this.querySelector(`#zf-reward-${id}`)?.addEventListener('click', e => {
      if (e.target === e.currentTarget) e.currentTarget.setAttribute('hidden','');
    });
  }
}
if (!customElements.get('zen-flow-experience')) {
  customElements.define('zen-flow-experience', ZenFlowExperience);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["zen-woman-experience"] && !Shopify.designMode) return;
  try {
    class ZenWomanExperience extends HTMLElement {
  connectedCallback() {
    this._blockId = this.querySelector('[data-game="grid"]').id.replace('zw-grid-', '');
    this._i18n = (window.zenWomanI18n && window.zenWomanI18n[this._blockId]) || {};
    this._code = this.dataset.code || 'MYBALANCE';
    this._discount = this.dataset.discount || (this._i18n.defaultDiscount || '20% de descuento en toda la gama divain. RITUAL');

    this._answers = [null, null, null, null];
    this._currentQ = 0;
    this._gameInited = false;
    this._mgMatched = 0;
    this._mgFlipped = [];
    this._mgProcessing = false;

    /* Ingredient images are static; text comes from i18n */
    var imgs = [
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/salvia.webp?v=1783425244',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/schisandra.webp?v=1783425245',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/yam.webp?v=1783425245',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/tulsi.webp?v=1783425244',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/probiotic.webp?v=1783425244',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/vitamin-c.webp?v=1783425244'
    ];
    var ingSrc = (this._i18n.ingredients) || [];
    this._ingredients = ingSrc.map(function (ing, idx) {
      return { id: ing.id, img: imgs[idx], name: ing.name, benefit: ing.benefit };
    });

    this._resultProfiles = this._i18n.resultProfiles || {};
    this._gameStrings = this._i18n.game || {};

    this._productImages = [
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/BALANCE.svg',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/MOOD.svg',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/FLORA.svg'
    ];

    this._bindEvents();
  }

  /* Watch data-code / data-discount for Theme Editor live updates */
  static get observedAttributes() { return ['data-code', 'data-discount']; }

  attributeChangedCallback(name, oldVal, newVal) {
    if (newVal === oldVal) return;
    if (name === 'data-code') {
      this._code = newVal || 'MYBALANCE';
      const el = this.querySelector('[data-modal="reward-code"]');
      if (el) el.textContent = this._code;
    }
    if (name === 'data-discount') {
      this._discount = newVal;
      const strong = this.querySelector('[data-modal="reward-discount"] strong');
      if (strong) strong.textContent = this._discount;
      const teaserStrong = this.querySelector('[data-protocol="teaser-discount"]');
      if (teaserStrong) teaserStrong.textContent = this._discount;
    }
  }

  /* ── HELPERS ── */
  _q(sel) { return this.querySelector(sel); }
  _qq(sel) { return this.querySelectorAll(sel); }

  _showScreen(name) {
    this._qq('.zw-screen').forEach(s => s.classList.remove('zw-screen--active'));
    const target = this._q('[data-screen="' + name + '"]');
    if (target) target.classList.add('zw-screen--active');
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── EVENTS ── */
  _bindEvents() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const action = btn.dataset.action;

      if (action === 'start-quiz')            { this._showScreen('quiz'); }
      else if (action === 'next-q')           { this._nextQ(parseInt(btn.dataset.from, 10)); }
      else if (action === 'go-to-q')          { this._goToQ(parseInt(btn.dataset.target, 10)); }
      else if (action === 'prev-q')           { if (this._currentQ > 0) this._goToQ(this._currentQ - 1); }
      else if (action === 'show-results')     { this._showResults(); }
      else if (action === 'start-game')       { this._showScreen('game'); this._initMemoryGame(); }
      else if (action === 'back-to-results')  { this._showScreen('results'); }
      else if (action === 'retake-quiz')      { this._retakeQuiz(); }
      else if (action === 'close-ingredient-modal') { this._closeIngredientModal(); }
      else if (action === 'copy-reward-code') { this._copyCode(btn); }
      else if (action === 'close-reward')     { this._q('.zw-reward-modal').hidden = true; }
    });

    /* Option buttons: select answer */
    this._qq('.zw-option').forEach(btn => {
      btn.addEventListener('click', () => {
        const qIdx = parseInt(btn.dataset.q, 10);
        const opt  = parseInt(btn.dataset.opt, 10);
        this._selectOption(qIdx, opt, btn);
      });
    });
  }

  /* ── QUIZ LOGIC ── */
  _selectOption(qIdx, opt, btn) {
    this._qq('[data-q="' + qIdx + '"].zw-option').forEach(b => {
      b.classList.remove('zw-option--selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('zw-option--selected');
    btn.setAttribute('aria-pressed', 'true');
    this._answers[qIdx] = opt;

    /* Enable next button for this question */
    const next = this._q('[data-action="next-q"][data-from="' + qIdx + '"], [data-action="show-results"][data-from="' + qIdx + '"]');
    if (next) { next.disabled = false; next.removeAttribute('aria-disabled'); }
  }

  _goToQ(n) {
    this._qq('.zw-question').forEach(q => q.classList.remove('zw-question--show'));
    const target = this._q('[data-q="' + n + '"].zw-question');
    if (target) target.classList.add('zw-question--show');

    this._qq('[data-dot]').forEach(dot => {
      const i = parseInt(dot.dataset.dot, 10);
      dot.className = 'zw-q-dot';
      if (i < n) dot.classList.add('zw-q-dot--done');
      else if (i === n) dot.classList.add('zw-q-dot--active');
    });

    const progressbar = this._q('[role="progressbar"]');
    if (progressbar) progressbar.setAttribute('aria-valuenow', n + 1);

    this._currentQ = n;
  }

  _nextQ(current) {
    if (this._answers[current] === null) return;
    this._goToQ(current + 1);
  }

  _showResults() {
    if (this._answers[3] === null) return;
    this._showScreen('loading');
    setTimeout(() => {
      this._buildResults();
      this._showScreen('results');
    }, 2200);
  }

  _buildResults() {
    const sym  = this._answers[0];
    const goal = this._answers[3];

    let key;
    if (sym === 0 || goal === 2) {
      key = 'a';
    } else if (sym === 1 || goal === 0) {
      key = 'b';
    } else if (sym === 2 || goal === 1) {
      key = 'c';
    } else {
      key = 'd';
    }

    const p = this._resultProfiles[key] || {};
    const title           = p.title           || '';
    const profile         = p.profile         || '';
    const intro           = p.intro           || '';
    const balancePriority = p.balance_priority || '';
    const moodPriority    = p.mood_priority   || '';

    const set = (sel, val) => { const el = this._q(sel); if (el) el.textContent = val; };
    set('[data-result="title"]',          title);
    set('[data-result="profile"]',        profile);
    set('[data-result="intro"]',          intro);
    set('[data-pc="balance-priority"]',   balancePriority);
    set('[data-pc="mood-priority"]',      moodPriority);
  }

  _retakeQuiz() {
    this._answers = [null, null, null, null];
    this._qq('.zw-option').forEach(b => {
      b.classList.remove('zw-option--selected');
      b.removeAttribute('aria-pressed');
    });
    this._qq('[data-action="next-q"], [data-action="show-results"]').forEach(b => {
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
    });
    this._goToQ(0);
    this._showScreen('quiz');
  }

  /* ── MEMORY GAME ── */
  _initMemoryGame() {
    if (this._gameInited) return;
    this._gameInited = true;
    this._mgMatched = 0; this._mgFlipped = []; this._mgProcessing = false;

    /* Dots */
    const dotsEl = this._q('[data-game="dots"]');
    dotsEl.innerHTML = '';
    for (let i = 0; i < 6; i++) {
      const d = document.createElement('div');
      d.className = 'zw-mg-dot';
      d.dataset.dotIdx = i;
      dotsEl.appendChild(d);
    }
    dotsEl.setAttribute('aria-valuenow', '0');

    /* Shuffle 12 cards */
    const cards = [...this._ingredients, ...this._ingredients];
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }

    const cardAria = this._gameStrings.cardAria || 'Carta boca abajo';
    const grid = this._q('[data-game="grid"]');
    grid.innerHTML = '';
    cards.forEach(ing => {
      const el = document.createElement('div');
      el.className = 'zw-mg-card';
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', cardAria);
      el.dataset.ingId = ing.id;
      el.innerHTML =
        '<div class="zw-mg-inner">' +
          '<div class="zw-mg-face zw-mg-back-face" aria-hidden="true">' +
            '<div class="zw-mg-back-icon">🌸</div>' +
            '<div class="zw-mg-back-brand">zen</div>' +
          '</div>' +
          '<div class="zw-mg-face zw-mg-front-face" aria-hidden="true">' +
            '<div class="zw-mg-ingredient-display">' +
              '<img class="zw-mg-front-img" src="' + ing.img + '" alt="" width="160" height="240" loading="lazy">' +
              '<div class="zw-mg-front-name-pill">' + ing.name + '</div>' +
            '</div>' +
            '<div class="zw-mg-matched-display">' +
              '<img class="zw-mg-product-img" src="" alt="" width="160" height="240" loading="lazy">' +
              '<div class="zw-mg-match-check" aria-hidden="true">✓</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      el.addEventListener('click', () => this._mgFlipCard(el));
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this._mgFlipCard(el); } });
      el.setAttribute('tabindex', '0');
      grid.appendChild(el);
    });
  }

  _mgFlipCard(el) {
    if (this._mgProcessing) return;
    if (el.classList.contains('zw-mg-card--flipped') || el.classList.contains('zw-mg-card--matched')) return;
    if (this._mgFlipped.length === 2) return;

    el.classList.add('zw-mg-card--flipped');
    el.setAttribute('aria-label', el.querySelector('.zw-mg-front-name-pill').textContent);
    this._mgFlipped.push(el);

    if (this._mgFlipped.length === 2) {
      this._mgProcessing = true;
      const [a, b] = this._mgFlipped;

      if (a.dataset.ingId === b.dataset.ingId) {
        /* Match */
        setTimeout(() => {
          const productImg = this._productImages[Math.floor(Math.random() * this._productImages.length)];
          [a, b].forEach(card => {
            card.querySelector('.zw-mg-product-img').src = productImg;
            card.classList.add('zw-mg-card--matched');
            card.classList.remove('zw-mg-card--flipped');
          });
          this._mgFlipped = [];
          this._mgMatched++;
          this._mgProcessing = false;

          /* Update dot */
          const dot = this._q('[data-dot-idx="' + (this._mgMatched - 1) + '"]');
          if (dot) dot.classList.add('zw-mg-dot--found');
          const dotsEl = this._q('[data-game="dots"]');
          if (dotsEl) dotsEl.setAttribute('aria-valuenow', this._mgMatched);

          const ing = this._ingredients.find(i => i.id == a.dataset.ingId);
          setTimeout(() => this._showIngredientModal(ing), 300);
        }, 400);
      } else {
        /* No match */
        setTimeout(() => {
          const cardAria = this._gameStrings.cardAria || 'Carta boca abajo';
          a.classList.remove('zw-mg-card--flipped'); b.classList.remove('zw-mg-card--flipped');
          a.setAttribute('aria-label', cardAria);
          b.setAttribute('aria-label', cardAria);
          this._mgFlipped = [];
          this._mgProcessing = false;
        }, 900);
      }
    }
  }

  _showIngredientModal(ing) {
    const modal = this._q('.zw-ingredient-modal');
    this._q('[data-modal="im-emoji"]').innerHTML = '<img src="' + ing.img + '" alt="' + ing.name + '" width="44" height="44" style="object-fit:contain;">';
    this._q('[data-modal="im-name"]').textContent  = ing.name;
    this._q('[data-modal="im-benefit"]').textContent = ing.benefit;
    const left = 6 - this._mgMatched;
    const pairsEl = this._q('[data-modal="im-pairs-left"]');
    if (left > 0) {
      const tmpl = this._gameStrings.pairsLeftTemplate || 'Quedan <strong>{n}</strong> por descubrir';
      pairsEl.innerHTML = tmpl.replace('{n}', String(left));
    } else {
      pairsEl.innerHTML = this._gameStrings.allFound || '¡Has encontrado todos los pares! 🎉';
    }
    modal.hidden = false;
    this._q('.zw-im-btn').focus();
  }

  _closeIngredientModal() {
    this._q('.zw-ingredient-modal').hidden = true;
    if (this._mgMatched === 6) {
      setTimeout(() => {
        const rewardModal = this._q('.zw-reward-modal');
        rewardModal.hidden = false;
        rewardModal.querySelector('[data-action="close-reward"]').focus();
      }, 500);
    }
  }

  _copyCode(btn) {
    const code = (this._q('[data-modal="reward-code"]') || {}).textContent || this._code;
    navigator.clipboard.writeText(code).catch(() => {
      /* Clipboard unavailable — silent fallback */
    });
    btn.classList.add('zw-reward-code-block--copied');
  }
}

if (!customElements.get('zen-woman-experience')) {
  customElements.define('zen-woman-experience', ZenWomanExperience);
}
  } catch(e) { console.error(e); }
})();

})();
